import { TokenObtainType } from "@/constants/auth";
import type { DefaultLoginResponse } from "@/types/auth.type";

/**
 *  Data Transfer Object
 *  Responsible for defining the data structure of the request and response
 */

export interface LoginPayload {
  email: string;
  password: string;
}

export type LoginResponse = DefaultLoginResponse | Root2FALoginResponse;

export interface Root2FALoginResponse {
  type: TokenObtainType.ROOT_2FA;
  authHeader: {
    name: "X-API-KEY";
    type: "APIKey";
  };
  data: {
    apiKey: string;
  };
}

export const isRoot2FAResponse = (data: unknown): data is Root2FALoginResponse => {
  return typeof data === "object" && data !== null && "type" in data && data.type === "root_2fa";
};
